import { useState } from "react";
import { IconEye } from "@tabler/icons-react";
import { TrackFrameViewer } from "@/components/track-frame-viewer/TrackFrameViewer";
import { TrackFrame } from "@/types/trackLabeling";
import { clampFramePosition } from "./utils";

type CorrectAnswerTrackViewerProps = {
  labeledFrames: TrackFrame[];
  initialFramePosition: number;
};

export const CorrectAnswerTrackViewer = ({
  labeledFrames,
  initialFramePosition,
}: CorrectAnswerTrackViewerProps) => {
  const totalFrames = labeledFrames.length;
  const [framePosition, setFramePosition] = useState(() =>
    clampFramePosition(initialFramePosition, totalFrames),
  );

  return (
    <div className="flex flex-col gap-3 rounded-[24px] bg-[#F4F7F9] p-4">
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-[#8695A8]">
          <IconEye size={13} />
          The track
        </span>
        <span className="rounded-lg bg-[#F0F3FF] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.1em] text-[#5A6EFA]">
          Frame {framePosition} / {totalFrames}
        </span>
      </div>

      <div className="relative min-h-[400px] flex-1 overflow-hidden rounded-[16px] bg-[#111624]">
        <div className="absolute inset-0">
          <TrackFrameViewer
            frames={labeledFrames}
            framePosition={framePosition}
            isTrackingConfirmed
          />
        </div>
      </div>

      <input
        type="range"
        min={1}
        max={Math.max(totalFrames, 1)}
        value={framePosition}
        onChange={(event) => setFramePosition(Number(event.target.value))}
        disabled={totalFrames <= 1}
        aria-label="Frame"
        aria-valuetext={`Frame ${framePosition} of ${totalFrames}`}
        className="w-full cursor-pointer accent-[#5A6EFA] disabled:cursor-default"
      />
    </div>
  );
};
